import _Vue from "vue";
import InnerModalDialogComponent from "../../components/modal-dialog/inner-modal-dialog";
// import LeavePageConfirm from "../../components/modal-dialog/inner-modal-dialog/leavePageConfirm";



export class PluginOptions { }

const ModalConfirmPlugin = {
    install(Vue: typeof _Vue, options?: PluginOptions) {
        Vue.prototype.$initInnerModalDialogComponent = function (i18n: any) {
            const vm = this;
            return new Promise(resolve => {
                let newInnerModalDialogComponent = new InnerModalDialogComponent({
                    i18n: i18n,
                    propsData: {
                        visible: false,
                        isSave: false,
                        isNew: false,
                        icon: 'fa fa-check-square-o',
                        width: '450px',
                        isDataChange: true,
                        contentConfirm: vm.$t('DATACHANGEWARNING').toString().split("|")[0],
                        title: vm.$t('DATACHANGEWARNING').toString().split("|")[1],

                    }
                });

                resolve(newInnerModalDialogComponent);
            });
        }

    }

}

export { ModalConfirmPlugin };

declare module 'vue/types/vue' {
    interface Vue {
        $initInnerModalDialogComponent: (i18n: any) => Promise<any>;
    }
}